module.exports = __webpack_public_path__ + "static/media/pdf.90b5c092.svg";